///////////////////////////////////////////////
//           Menu Item styles                //
///////////////////////////////////////////////

@import './pk-menu-item.variables';

:host {
  @apply block;
}

.pk-menu__item {
  @apply button-reset relative box-border flex w-full flex-1 items-center border-0;
  @apply text-[length:--menu-item--font-size] leading-m text-[color:--menu-item--color] no-underline;
  @apply pb-[--menu-item--padding-bottom] pl-[--menu-item--padding-left] pr-[--menu-item--padding-right] pt-[--menu-item--padding-top];
  @apply transition-[background-color] duration-250;
  @apply [--pk-focus-offset-width:-4px] focus-visible:focus-outline;

  font-family: var(--menu-item--font-family);
  border-bottom: var(--menu-item--border-bottom);

  &.selected {
    @apply bg-[--menu-item--selected-bg];
  }

  &.active {
    @apply cursor-pointer bg-[--menu-item--hover-bg];
  }
}

.level-2 {
  padding-left: calc(var(--menu-item--padding-left) * 2);
  @apply font-regular;

  &.expanded {
    @apply font-semibold;
  }
}

.highlight {
  @apply border-l-4 border-l-transparent;
  border-left-style: solid;

  &.selected:not(.expanded) {
    @apply border-l-interaction;
  }
}

.has-border {
  @apply border-l-4 border-l-interaction;
  border-left-style: solid;
}

.pk-menu__item--prefix {
  ::slotted(*) {
    --pk-icon--color: inherit;
    @apply mr-[--menu-item-prefix--margin-right];
  }
}

.pk-menu__item--suffix {
  ::slotted(*) {
    --pk-icon--color: inherit;
    @apply ml-[--menu-item-suffix--margin-left];
  }
}

.pk-menu__item--navigation-icon {
  --pk-icon--color: inherit;
  @apply rotate-0 transition-transform duration-250;
}

.pk-menu__item.expanded {
  @apply bg-elevation-03;

  @media (hover: hover) and (pointer: fine) {
    @apply hover:bg-[--menu-item--hover-bg];
  }

  .pk-menu__item--navigation-icon {
    @apply rotate-180;
  }
}

.pk-menu__item--submenu {
  @apply grid bg-elevation-03 opacity-0 transition-[grid-template-rows,opacity] duration-250;
  grid-template-rows: 0fr;

  &.expanded {
    @apply opacity-100;
    grid-template-rows: 1fr;
  }
}
